import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/components/Megamenu.scss';
import { useCart } from '../context/CartContext';

import downArrow from '../assets/icons/downArrow.svg';
import nature from '../assets/icons/nature.svg';
import smartCoti from '../assets/logos/smart_coti-logo.svg';

const Megamenu = () => {
  const { openSmartCoti } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [activeCategory, setActiveCategory] = useState(null);

  const handleMouseEnter = (category) => {
    setActiveCategory(category);
  };

  const handleMouseLeave = () => {
    setActiveCategory(null);
  };

  const handleDealsClick = (e) => {
    e.preventDefault();
    
    if (location.pathname === '/') {
      const target = document.getElementById('deals');
      if (!target) return;
      
      const HEADER_OFFSET = 300;
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - HEADER_OFFSET,
        behavior: 'smooth',
      });
    } else {
      navigate('/#deals');
      
      setTimeout(() => {
        const target = document.getElementById('deals');
        if (target) {
          const HEADER_OFFSET = 400;
          const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - HEADER_OFFSET,
            behavior: 'smooth',
          });
        }
      }, 100);
    }
  };

  return (
    <div className="megamenu">
      <a
        href="#deals"
        className="btn btn-primary mr-5"
        onClick={handleDealsClick}
      >
        Ofertas
      </a>
      <a
        href="/productos/todos"
        className="btn btn-primary highlighted mr-5"
      >
        Todos los productos
      </a>
      <a
        href="/categorias/ecologia-ecopromo"
        className="btn btn-tertiary highlighted mr-5 btn-icon"
      >
        <img
          src={nature}
          alt="Arrow"
          className="menu-icon"
        />
        Ecología 
      </a>
      <a
        href="/categorias"
        className="btn btn-primary highlighted green"
      >
        Categorias y productos
      </a>
      <a
        href="#"
        className="btn-abstract"
        id="smart-coti"
        onClick={(e) => {
          e.preventDefault();
          openSmartCoti();
        }}
      >
        <img
          src={smartCoti}
          alt="Cotización inteligente"
          className="menu-icon"
          loading="lazy"
        />
      </a>
    </div>
  );
};

export default Megamenu;